"use client";

import { SiteTemplatePageSectionTypeDoctorsSettingModel } from "@/Apis/ClinicApi";
import { Helper } from "@/Helpers";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { useT } from "@/Hooks";
import { DoctorsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedDoctorsSection from "../Components/GeneratedDoctorsSection";

const Doctors: FC<DoctorsSectionProps> = (props) => {
  const t = useT();
  const showBlueTickTitle = false;
  // const showBlueTickTitle =
  //   props.setting.OnlyBlueTickedDoctorsStatus?.Key ===
  //     CenterOptions.Enum.Status.Active.key &&
  //   !props.setting.Description?.trim();

  const sectionProps = showBlueTickTitle
    ? {
      ...props,
      setting: {
        ...props.setting,
        Description: t("landing.doctors.blueTickedTitle"),
      },
    }
    : props;

  return <GeneratedDoctorsSection {...sectionProps} />;
};

export default Doctors;

export const defaultDoctorsSetting: SiteTemplatePageSectionTypeDoctorsSettingModel =
{
  Title: "",
  Description: "",
  OnlyBlueTickedDoctorsStatus: Helper.centerOptionObjectToCenterOptionModel(CenterOptions.Enum.Status.InActive),
  ItemsDisplayMode: Helper.centerOptionObjectToCenterOptionModel(
    CenterOptions.SiteTemplate.SiteTemplateSettings.ItemsDisplayMode.Grid,
  ),
  Appearance: Helper.centerOptionObjectToCenterOptionModel(
    CenterOptions.SiteTemplate.SiteTemplateSettings
      .SiteTemplateDoctorsAppearance.Default,
  ),
};
